import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as userActions from "../../actions/userActions";
import * as departmentActions from "../../actions/departmentActions";
import * as codeActions from "../../actions/codeActions";
import * as roleActions from "../../actions/roleActions";
import * as serviceActions from "../../actions/serviceActions";
import * as modalActions from "../../actions/modalActions";
import * as taxCodeActions from "../../actions/taxCodeActions";

import ServiceForm from "./ServiceForm";
import HeaderWrapper from "../common/HeaderWrapper";

const ServiceAddPage = ({
  users,
  roles,
  departments,
  actions,
  service,
  history,
  codes,
  services,
  savingService,
  taxCodes
}) => {
  useEffect(() => {
    if (!roles.length) actions.loadRoles();
  }, [actions, roles]);

  useEffect(() => {
    if (!departments.length) actions.loadDepartments();
  }, [actions, departments.length]);

  useEffect(() => {
    if (!users.length) actions.loadUsers();
  }, [actions, users.length]);

  useEffect(() => {
    if (!taxCodes.length) {
      actions.loadTaxCodes();
    }
  }, [actions, taxCodes.length]);

  const handleAdd = (newService) => {
    actions.createService(newService);
  };

  const handleCancel = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <HeaderWrapper breadcrumbs={[{ label: "Add Service" }]} />
      <div className="content-wrapper">
        <ServiceForm
          service={service}
          services={services}
          departments={departments}
          codes={codes}
          onAdd={handleAdd}
          onCancel={handleCancel}
          saving={savingService}
          adding
          taxCodes={taxCodes}
        />
      </div>
    </React.Fragment>
  );
};

ServiceAddPage.propTypes = {
  actions: PropTypes.object.isRequired,
  users: PropTypes.array,
  departments: PropTypes.array,
  codes: PropTypes.array,
  roles: PropTypes.array,
  service: PropTypes.object,
  services: PropTypes.array,
  history: PropTypes.object,
  savingService: PropTypes.bool,
  taxCodes: PropTypes.array
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    users: state.reducers.users,
    departments: state.reducers.departments,
    codes: state.reducers.codes,
    roles: state.reducers.roles,
    service: state.reducers.service,
    savingService: state.reducers.savingService,
    services: state.reducers.services,
    taxCodes: state.reducers.taxCodes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userActions,
        ...departmentActions,
        ...codeActions,
        ...roleActions,
        ...serviceActions,
        ...modalActions,
        ...taxCodeActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ServiceAddPage);
